// extracted by mini-css-extract-plugin
module.exports = {"arrow":"arrow_arrow__3CoRT","open":"arrow_open__TsNob"};